import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;

  @media (max-width: 576px) {
    padding: 16px;
  }
`;

export const TableContainer = styled.div`
  margin-top: 16px;
`;
